<mat-card>
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>{{ group.name }}</mat-card-title>
      <div class="btn-group">
        <div
          [class]="hasAssessment() ? 'disabled-button' : ''"
          [matTooltip]="
            hasAssessment() ? 'Un groupe contenant des évaluations ne peut pas être modifié' : 'Modifier le groupe'
          ">
          <button class="btn btn-outline-primary btn-sm" (click)="modifyGroup()" [disabled]="hasAssessment()">
            <span class="material-symbols-outlined pt-1">edit</span>
          </button>
        </div>
        <button
          class="btn btn-outline-primary btn-sm border-start-0"
          [routerLink]="['/groupStats/', group.id]"
          matTooltip="Consulter les résultats">
          <span class="material-symbols-outlined pt-1">monitoring</span>
        </button>
        <div
          [class]="group.protected ? 'disabled-button' : ''"
          [matTooltip]="
            group.protected ? 'Il n\'est pas possible de supprimer un groupe protegé' : 'Supprimer le groupe'
          ">
          <button class="btn btn-outline-danger btn-sm" (click)="deleteGroup()" [disabled]="group.protected">
            <span class="material-symbols-outlined pt-1">delete</span>
          </button>
        </div>
      </div>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    <!-- Description -->
    <div class="row">
      <div class="col-auto title">Description :</div>
      @if (!!group.description) {
      <div class="col-auto text">{{ group.description }}</div>
      }
    </div>
  </mat-card-content>
</mat-card>
